import React from 'react';
import './Start.scss';
import image from '../../../Assets/Cards/subscribeImg.webp';
import Styledlink from '../StyledLink/StyledLink';
const Start=()=>{
    return(
        <div className="shared-start">
         <div className="content">
         <h1>Ready to get started?</h1>
         <p>20,000 + designers from all around the world already use Hotstyle to improve design collaboration and get design done.</p>
         </div>
         <div className="btns">
             <Styledlink btn="Signup for free" styles="whitebtn"/>
             <Styledlink btn="No Credit Card Required" styles="outline"/>
         </div>
        </div>
    )
};
export default Start ;